import { __decorate, __extends, __metadata } from "tslib";
import { DataViewBase } from './DataView';
import { Observable } from '../Model/Decorators';
import NeoModel from '../Model/NeoModel';
var WindowedDataView = /** @class */ (function (_super) {
    __extends(WindowedDataView, _super);
    function WindowedDataView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._position = 0;
        _this.maxItems = 0;
        return _this;
    }
    Object.defineProperty(WindowedDataView.prototype, "position", {
        get: function () {
            return this._position;
        },
        set: function (value) {
            this._position = Math.max(0, Math.min(value, this.sortedItems.length - this.maxItems));
        },
        enumerable: false,
        configurable: true
    });
    WindowedDataView.prototype.getItems = function () {
        var sortedItems = this.sortedItems;
        if (this.maxItems) {
            var window_1 = [];
            var start = Math.min(this._position, Math.max(0, sortedItems.length - this.maxItems));
            for (var i = start; i < Math.min(sortedItems.length, this._position + this.maxItems); i++) {
                window_1.push(sortedItems[i]);
            }
            return window_1;
        }
        else {
            return sortedItems;
        }
    };
    __decorate([
        Observable(),
        __metadata("design:type", Number)
    ], WindowedDataView.prototype, "_position", void 0);
    __decorate([
        Observable(),
        __metadata("design:type", Number)
    ], WindowedDataView.prototype, "maxItems", void 0);
    WindowedDataView = __decorate([
        NeoModel
    ], WindowedDataView);
    return WindowedDataView;
}(DataViewBase));
export { WindowedDataView };
